export default [
  {
    path: "/",
    name: "HomePage",
    component: () => import("@/pages/HomePage.vue"),
    meta: {
      breadcrumb: [{label: "Dashboard"}],
      requireLogin: true,
      layout: 'App',
      module: 'dashboard',
      hideBreadcrumb: true
    },
  },

  {
    path: "/test",
    name: "TestPage",
    component: () => import("@/pages/Test.vue"),
    meta: {
      requireLogin: true,
      layout: 'App'
    }
  },

  {
    path: "/map/",
    name: "MapPage",
    component: () => import("@/pages/MapPage.vue"),
    meta: {
      breadcrumb: [{label: "Map"}],
      requireLogin: true,
      layout: 'App',
      module: 'map',
      hideBreadcrumb: true,
      fullWidth: true
    },
  },

  {
    path: "/projects/",
    name: "ProjectsPage",
    component: () => import("@/pages/gis/ProjectsPage.vue"),
    meta: {
      breadcrumb: [{label: "Projects"}],
      requireLogin: true,
      layout: 'App',
      module: 'project',
      requiredRight: 'view'
    },
  },

  {
    path: "/temporary-projects/",
    name: "TemporaryProjectsPage",
    component: () => import("@/pages/gis/TemporaryProjectsPage.vue"),
    meta: {
      breadcrumb: [{label: "Temporary Projects"}],
      requireLogin: true,
      layout: 'App',
      module: 'temporaryProject',
      requiredRight: 'view'
    },
  },

  {
    path: "/private-projects/",
    name: "PrivateProjectsPage",
    component: () => import("@/pages/gis/PrivateProjectsPage.vue"),
    meta: {
      breadcrumb: [{label: "Private Projects"}],
      requireLogin: true,
      layout: 'App',
      module: 'privateProject',
      requiredRight: 'view'
    },
  },

  {
    path: "/layers/",
    name: "LayersPage",
    component: () => import("@/pages/gis/LayersPage.vue"),
    meta: {
      breadcrumb: [{label: "Layers"}],
      requireLogin: true,
      layout: 'App',
      module: 'layer',
      requiredRight: 'view'
    }
  },

  {
    path: "/temporary-layers/",
    name: "TemporaryLayersPage",
    component: () => import("@/pages/gis/TemporaryLayersPage.vue"),
    meta: {
      breadcrumb: [{label: "TemporaryLayers"}],
      requireLogin: true,
      layout: 'App',
      module: 'temporaryLayer',
      requiredRight: 'view'
    }
  },

  {
    path: "/private-layers/",
    name: "PrivateLayersPage",
    component: () => import("@/pages/gis/PrivateLayersPage.vue"),
    meta: {
      breadcrumb: [{label: "PrivateLayers"}],
      requireLogin: true,
      layout: 'App',
      module: 'privateLayer',
      requiredRight: 'view'
    }
  },

  {
    path: "/shares/",
    name: "SharesPage",
    component: () => import("@/pages/gis/SharesPage.vue"),
    meta: {
      breadcrumb: [{label: "Shares"}],
      requireLogin: true,
      layout: 'App',
      module: 'share',
      requiredRight: 'view'
    }
  },

  {
    path: "/documents/",
    name: "DocumentsPage",
    component: () => import("@/pages/documents/DocumentsPage.vue"),
    meta: {
      breadcrumb: [{label: "Documents"}],
      requireLogin: true,
      layout: 'App',
      module: 'document',
      requiredRight: 'view'
    }
  },

  {
    path: "/apps/",
    name: "AppsPage",
    component: () => import("@/pages/gis/AppsPage.vue"),
    meta: {
      breadcrumb: [{label: "Apps"}],
      requireLogin: true,
      layout: 'App',
      module: 'iframe',
      requiredRight: 'view'
    }
  },

  {
    path: "/app/:documentId",
    name: "EditAppPage",
    component: () => import("@/pages/gis/AppPage.vue"),
    meta: {
      breadcrumb: [{label: "App"}],
      requireLogin: true,
      layout: 'App',
      module: 'iframe',
      requiredRight: 'add',
      hideBreadcrumb: true,
      fullWidth: true
    }
  },

  {
    path: "/app/",
    name: "CreateAppPage",
    component: () => import("@/pages/gis/AppPage.vue"),
    meta: {
      breadcrumb: [{label: "App"}],
      requireLogin: true,
      layout: 'App',
      module: 'iframe',
      requiredRight: 'add',
      hideBreadcrumb: true
    }
  },

  {
    path: "/integrations/",
    name: "IntegrationsPage",
    component: () => import("@/pages/gis/IntegrationsPage.vue"),
    meta: {
      breadcrumb: [{label: "Integration"}],
      requireLogin: true,
      layout: 'App',
      module: 'integration',
      requiredRight: 'view'
    }
  },

  {
    path: "/integration/:documentId",
    name: "EditIntegrationPage",
    component: () => import("@/pages/gis/IntegrationPage.vue"),
    meta: {
      breadcrumb: [{label: "Edit Integration"}],
      requireLogin: true,
      layout: 'App',
      module: 'integration',
      requiredRight: 'add',
      hideBreadcrumb: true
    }
  },

  {
    path: "/integration/",
    name: "IntegrationPage",
    component: () => import("@/pages/gis/IntegrationPage.vue"),
    meta: {
      breadcrumb: [{label: "New Integration"}],
      requireLogin: true,
      layout: 'App',
      module: 'integration',
      requiredRight: 'add',
      hideBreadcrumb: true
    }
  },

  {
    path: "/users/",
    name: "UsersPage",
    component: () => import("@/pages/user/UsersPage.vue"),
    meta: {
      breadcrumb: [{label: "Users"}],
      requireLogin: true,
      layout: 'App',
      module: 'user',
      requiredRight: 'view'
    }
  },

  {
    path: "/user/",
    name: "UserPage",
    component: () => import("@/pages/user/UserPage.vue"),
    meta: {
      breadcrumb: [{label: "Create user"}],
      requireLogin: true,
      layout: 'App',
      module: 'user',
      requiredRight: 'add',
      hideBreadcrumb: true
    }
  },

  {
    path: "/user/:userId",
    name: "EditUserPage",
    component: () => import("@/pages/user/UserPage.vue"),
    meta: {
      breadcrumb: [{label: "Edit user"}],
      requireLogin: true,
      layout: 'App',
      module: 'user',
      requiredRight: 'add',
      hideBreadcrumb: true
    }
  },

  {
    path: "/roles/",
    name: "UserRolesPage",
    component: () => import("@/pages/user/UsersRolesPage.vue"),
    meta: {
      breadcrumb: [{label: "User Roles"}],
      requireLogin: true,
      layout: 'App',
      module: 'role',
      requiredRight: 'view',
      fullWidth: true
    }
  },

  {
    path: "/document-categories/",
    name: "DocumentCategoryPage",
    component: () => import("@/pages/documents/DocumentCategoryPage.vue"),
    meta: {
      breadcrumb: [{label: "Document categories"}],
      requireLogin: true,
      layout: 'App',
      module: 'DocumentCategories',
      requiredRight: 'view',
      hideBreadcrumb: true
    }
  },

  {
    path: "/schemas/",
    name: "SchemasPage",
    component: () => import("@/pages/documents/SchemasPage.vue"),
    meta: {
      breadcrumb: [{label: "Schemas"}],
      requireLogin: true,
      layout: 'App',
      module: 'Schemas',
      requiredRight: 'view'
    }
  },

  {
    path: '/document-detail-categories/',
    name: 'DocumentDetailCategoryPage',
    component: () => import('@/pages/documents/DocumentDetailCategoryPage.vue'),
    meta: {
      breadcrumb: [{ label: 'Document detail category' }],
      requireLogin: true,
      layout: 'App',
      module: 'DocumentDetailCategories',
      requiredRight: 'view',
      hideBreadcrumb: true
    }
  },

  {
    path: "/users-role/",
    name: "CreateUsersRolePage",
    component: () => import("@/pages/user/UsersRolePage.vue"),
    meta: {
      breadcrumb: [{label: "Create Role"}],
      requireLogin: true,
      layout: 'App',
      module: 'role',
      requiredRight: 'add',
      hideBreadcrumb: true
    }
  },

  {
    path: "/users-role/:roleId",
    name: "EditUsersRolePage",
    component: () => import("@/pages/user/UsersRolePage.vue"),
    meta: {
      breadcrumb: [{label: "Edit Role"}],
      requireLogin: true,
      layout: 'App',
      module: 'role',
      requiredRight: 'add',
      hideBreadcrumb: true
    }
  },

  {
    path: "/attributes/",
    name: "AttributesPage",
    component: () => import("@/pages/gis/AttributesPage.vue"),
    meta: {
      breadcrumb: [{label: "Attributes"}],
      requireLogin: true,
      layout: 'App',
      module: 'attribute',
      requiredRight: 'view'
    }
  },

  {
    path: "/profile/",
    name: "ProfilePage",
    component: () => import("@/pages/user/ProfilePage.vue"),
    meta: {
      breadcrumb: [{label: "Profile"}],
      requireLogin: true,
      layout: 'App',
      module: 'profile',
      requiredRight: 'view'
    }
  },

  {
    path: "/settings/",
    name: "SettingsPage",
    component: () => import("@/pages/SettingsPage.vue"),
    meta: {
      breadcrumb: [{label: "Settings"}],
      requireLogin: true,
      layout: 'App',
      module: 'settings',
      requiredRight: 'view'
    }
  },

  {
    path: "/login/",
    name: "Login",
    component: () => import("@/pages/user/Login.vue"),
    meta: {
      breadcrumb: [{label: "Login"}],
      requireLogin: false,
      layout: 'LoginLayout'
    },
  },

  {
    path: "/recover-password/",
    name: "RecoverPassword",
    component: () => import("@/pages/user/RecoverPassword.vue"),
    meta: {
      breadcrumb: [{label: "Recover password"}],
      requireLogin: false,
      layout: 'RecoverPasswordLayout'
    },
  },

  {
    path: "/reset-password/",
    name: "ResetPassword",
    component: () => import("@/pages/user/ResetPassword.vue"),
    meta: {
      breadcrumb: [{label: "Reset password"}],
      requireLogin: false,
      layout: 'ResetPasswordLayout'
    },
  },

  {
    path: "/embed/:apiKeyAlias?",
    name: "Embed",
    component: () => import("@/pages/EmbedPage.vue"),
    meta: {
      requireLogin: false,
      layout: 'App',
      module: 'layer',
      requiredRight: 'view',
      hideBreadcrumb: true,
      fullWidth: true
    },
  },

  {
    path: "/galleries/",
    name: "PhotoGalleriesPage",
    component: () => import("@/pages/documents/PhotoGalleriesPage.vue"),
    meta: {
      breadcrumb: [{label: "Photo galleries"}],
      requireLogin: true,
      layout: 'App',
      module: 'photoGallery',
      requiredRight: 'view'
    }
  },

  {
    path: "/nomenclature/",
    name: "NomenclaturesPage",
    component: () => import("@/pages/documents/NomenclaturesPage.vue"),
    meta: {
      breadcrumb: [{label: "Nomenclature"}],
      requireLogin: true,
      layout: 'App',
      module: 'nomenclature',
      requiredRight: 'view'
    }
  },

  {
    path: "/add-nomenclature/",
    name: "AddNomenclaturePage",
    component: () => import("@/pages/documents/NomenclaturePage.vue"),
    meta: {
      breadcrumb: [{label: "Create document"}],
      requireLogin: true,
      layout: 'App',
      module: 'nomenclature',
      requiredRight: 'add',
      hideBreadcrumb: true
    }
  },

  {
    path: "/edit-nomenclature/:documentId",
    name: "EditNomenclaturePage",
    component: () => import("@/pages/documents/NomenclaturePage.vue"),
    meta: {
      breadcrumb: [{label: "Edit document"}],
      requireLogin: true,
      layout: 'App',
      module: 'nomenclature',
      requiredRight: 'edit',
      hideBreadcrumb: true,
      fullWidth: true
    }
  },

  {
    path: "/organizations/",
    name: "OrganizationsPage",
    component: () => import("@/pages/organization/OrganizationsPage.vue"),
    meta: {
      breadcrumb: [{label: "Organizations"}],
      requireLogin: true,
      layout: 'App',
      module: 'organization',
      requiredRight: 'view'
    }
  },

  {
    path: "/partners/",
    name: "PartnersPage",
    component: () => import("@/pages/organization/OrganizationPartners.vue"),
    meta: {
      breadcrumb: [{label: "Partners"}],
      requireLogin: true,
      layout: 'App',
      module: 'PartnerList',
      requiredRight: 'view'
    }
  },

  {
    path: "/organizations/categories/",
    name: "OrganizationCategories",
    component: () => import("@/pages/organization/OrganizationCategories.vue"),
    meta: {
      breadcrumb: [{label: "Categories"}],
      requireLogin: true,
      layout: 'App',
      module: 'OrganizationCategory',
      requiredRight: 'view',
      hideBreadcrumb: true
    }
  },

  {
    path: "/organizations/types/",
    name: "OrganizationTypes",
    component: () => import("@/pages/organization/OrganizationTypes.vue"),
    meta: {
      breadcrumb: [{label: "Types"}],
      requireLogin: true,
      layout: 'App',
      module: 'OrganizationType',
      requiredRight: 'view'
    }
  },

  {
    path: "/organizations/jobs/",
    name: "OrganizationJobs",
    component: () => import("@/pages/organization/OrganizationJobs.vue"),
    meta: {
      breadcrumb: [{label: "Jobs"}],
      requireLogin: true,
      layout: 'App',
      module: 'OrganizationJob',
      requiredRight: 'view'
    }
  },

  {
    path: "/organizations/employees/",
    name: "OrganizationEmployees",
    component: () => import("@/pages/organization/OrganizationEmployees.vue"),
    meta: {
      breadcrumb: [{label: "Employees"}],
      requireLogin: true,
      layout: 'App',
      module: 'OrganizationEmployee',
      requiredRight: 'view'
    }
  },

  {
    path: '/manage-organization/:organizationId?',
    name: 'OrganizationManagement',
    component: () => import('@/pages/organization/OrganizationManagement.vue'),
    meta: {
      breadcrumb: [{ label: 'Organization Management' }],
      requireLogin: true,
      layout: 'App',
      module: 'OrganizationManagement',
      requiredRight: 'view',
      hideBreadcrumb: true
    },
    children: [
      {
        path: 'partners/:organizationRelationId',
        component: () => import('@/pages/organization/OrganizationManagement.vue'),
      },
    ],
  },


  {
    path: "/region/",
    name: "Region",
    component: () => import("@/pages/region/Region.vue"),
    meta: {
      breadcrumb: [{label: "Region"}],
      requireLogin: true,
      layout: 'App',
      module: 'region',
      requiredRight: 'view'
    }
  },

  {
    path: "/region/cities/",
    name: "Cities",
    component: () => import("@/pages/region/Cities.vue"),
    meta: {
      breadcrumb: [{label: "Cities"}],
      requireLogin: true,
      layout: 'App',
      module: 'Cities',
      requiredRight: 'view'
    }
  },

  {
    path: "/region/counties/",
    name: "Counties",
    component: () => import("@/pages/region/Counties.vue"),
    meta: {
      breadcrumb: [{label: "Counties"}],
      requireLogin: true,
      layout: 'App',
      module: 'Counties',
      requiredRight: 'view'
    }
  },

  {
    path: "/region/countries/",
    name: "Countries",
    component: () => import("@/pages/region/Countries.vue"),
    meta: {
      breadcrumb: [{label: "Countries"}],
      requireLogin: true,
      layout: 'App',
      module: 'Countries',
      requiredRight: 'view'
    }
  },

  {
    path: "/settings/tasks/",
    name: "Tasks",
    component: () => import("@/pages/settings/Tasks.vue"),
    meta: {
      breadcrumb: [{label: "Tasks"}],
      requireLogin: true,
      layout: 'App',
      module: 'Tasks',
      requiredRight: 'view'
    },
  },

  {
    path: "/settings/task-categories/",
    name: "Task categories",
    component: () => import("@/pages/settings/TaskCategories.vue"),
    meta: {
      breadcrumb: [{label: "Task categories"}],
      requireLogin: true,
      layout: 'App',
      module: 'TaskCategories',
      requiredRight: 'view',
      hideBreadcrumb: true
    },
  },

  {
    path: "/settings/statuses/",
    name: "Statuses",
    component: () => import("@/pages/settings/Statuses.vue"),
    meta: {
      breadcrumb: [{label: "Status"}],
      requireLogin: true,
      layout: 'App',
      module: 'Statuses',
      requiredRight: 'view'
    },
  },

  {
    path: "/settings/usertypes/",
    name: "UserTypes",
    component: () => import("@/pages/settings/UserTypes.vue"),
    meta: {
      breadcrumb: [{label: "User types"}],
      requireLogin: true,
      layout: 'App',
      module: 'UserTypes',
      requiredRight: 'view'
    },
  },

  {
    path: "/settings/tokentypes/",
    name: "TokenTypes",
    component: () => import("@/pages/settings/TokenTypes.vue"),
    meta: {
      breadcrumb: [{label: "Token types"}],
      requireLogin: true,
      layout: 'App',
      module: 'TokenTypes',
      requiredRight: 'view'
    },
  },

  {
    path: "/flows/:flowId?",
    name: "Flows",
    component: () => import("@/pages/documents/FlowsPage.vue"),
    meta: {
      breadcrumb: [{label: "Flows"}],
      requireLogin: true,
      layout: 'App',
      module: 'Flow',
      requiredRight: 'view'
    }
  },

  {
    path: "/sql-scripts/",
    name: "SQLScripts",
    component: () => import("@/pages/documents/SQLScriptsPage.vue"),
    meta: {
      breadcrumb: [{label: "SQL Scripts"}],
      requireLogin: true,
      layout: 'App',
      module: 'SQLScript',
      requiredRight: 'view'
    }
  },

  {
    path: "/analytics/",
    name: "Analytics",
    component: () => import("@/pages/documents/AnalyticsPage.vue"),
    meta: {
      breadcrumb: [{label: "Analytics Templates"}],
      requireLogin: true,
      layout: 'App',
      module: 'Analytics',
      requiredRight: 'view'
    }
  },

  {
    path: "/triggers/",
    component: () => import("@/pages/documents/TriggersPage.vue"),
    name: "Triggers",
    meta: {
      breadcrumb: [{label: "Triggers"}],
      requireLogin: true,
      layout: 'App',
      module: 'Trigger',
      requiredRight: 'view'
    }
  },

  {
    path: "/forms/",
    name: "Forms",
    component: () => import("@/pages/documents/FormTemplatesPage.vue"),
    meta: {
      breadcrumb: [{label: "Forms"}],
      requireLogin: true,
      layout: 'App',
      module: 'form',
      requiredRight: 'view'
    }
  },

  {
    path: "/add-form/",
    name: "AddForm",
    component: () => import("@/pages/documents/FormTemplatePage.vue"),
    meta: {
      breadcrumb: [{label: "Create form"}],
      requireLogin: true,
      layout: 'App',
      module: 'form',
      requiredRight: 'add',
      hideBreadcrumb: true,
      fullWidth: true
    }
  },

  {
    path: "/edit-form/:documentId",
    name: "EditForm",
    component: () => import("@/pages/documents/FormTemplatePage.vue"),
    meta: {
      breadcrumb: [{label: "Edit form"}],
      requireLogin: true,
      layout: 'App',
      module: 'form',
      requiredRight: 'edit',
      hideBreadcrumb: true,
      fullWidth: true
    }
  },

  {
    path: "/processes/",
    name: "Processes",
    component: () => import("@/pages/documents/ProcessesPage.vue"),
    meta: {
      breadcrumb: [{label: "Processes"}],
      requireLogin: true,
      layout: 'App',
      module: 'processes',
      requiredRight: 'view'
    }
  },

  {
    path: "/add-process/",
    name: "AddProcess",
    component: () => import("@/pages/documents/ProcessPage.vue"),
    meta: {
      breadcrumb: [{label: "Create process"}],
      requireLogin: true,
      layout: 'App',
      module: 'process',
      requiredRight: 'add',
      hideBreadcrumb: true,
      fullWidth: true
    }
  },

  {
    path: "/edit-process/:documentId",
    name: "EditProcess",
    component: () => import("@/pages/documents/ProcessPage.vue"),
    meta: {
      breadcrumb: [{label: "Edit process"}],
      requireLogin: true,
      layout: 'App',
      module: 'process',
      requiredRight: 'edit',
      hideBreadcrumb: true,
      fullWidth: true
    }
  },

  {
    path: "/tickets/",
    name: "Tickets",
    component: () => import("@/pages/tickets/TicketsPage.vue"),
    meta: {
      breadcrumb: [{label: "Tickets"}],
      requireLogin: true,
      layout: 'App',
      module: 'tickets',
      requiredRight: 'view'
    }
  },

  {
    path: "/ticket/:documentId",
    name: "TicketForm",
    component: () => import("@/pages/tickets/TicketPage.vue"),
    meta: {
      breadcrumb: [{label: "Ticket details"}],
      requireLogin: true,
      layout: 'App',
      module: 'ticket',
      requiredRight: 'edit',
      hideBreadcrumb: true
    }
  },

  {
    path: "/modules/",
    name: "Modules",
    component: () => import("@/pages/ModulesPage.vue"),
    meta: {
      breadcrumb: [{label: "Modules"}],
      requireLogin: true,
      layout: 'App',
      module: 'modules',
      requiredRight: 'view',
      hideBreadcrumb: true
    }
  },

  {
    path: "/page/:formId/:slug?",
    name: "FormRender",
    component: () => import("@/pages/documents/FormRenderPage.vue"),
    meta: {
      breadcrumb: [{label: "Form Page"}],
      requireLogin: true,
      layout: 'App',
      hideBreadcrumb: true
    }
  },

  {
    path: "/report-designer/:reportId?",
    name: "Report Designer",
    component: () => import('@/pages/report/View.vue'),
    meta: {
      breadcrumb: [{ label: 'Report Designer' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      hideBreadcrumb: true,
      fullWidth: true
    }
  },

  {
    path: "/report-templates",
    name: "Report Templates",
    component: () => import('@/pages/report/ReportTemplatesPage.vue'),
    meta: {
      breadcrumb: [{ label: 'Report Templates' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view'
    }
  },

  {
    path: "/report-viewer/:reportId?",
    name: "Report Viewer",
    component: () => import('@/pages/report/ReportViewer.vue'),
    meta: {
      breadcrumb: [{ label: 'Report Viewer' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      hideBreadcrumb: true,
      fullWidth: true
    }
  },

  {
    path: "/dashboard/:moduleCode",
    name: "ModuleDashboard",
    component: () => import("@/pages/ModuleDashboardPage.vue"),
    meta: {
      breadcrumb: [{label: "Module Dashboard Page"}],
      requireLogin: true,
      layout: 'App'
    }
  },

  {
    path: "/settings-types/",
    name: "Settings types",
    component: () => import('@/pages/settings/SettingsTypes.vue'),
    meta: {
      breadcrumb: [{ label: 'Settings types' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'SettingsTypes',
    }
  },

  {
    path: "/settings-list/",
    name: "Settings list",
    component: () => import('@/pages/settings/SettingsList.vue'),
    meta: {
      breadcrumb: [{ label: 'Settings list' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'SettingsList',
    }
  },

  {
    path: "/virtual-tour/",
    name: "Virtual tours",
    component: () => import('@/pages/virtual-tour/VirtualToursPage.vue'),
    meta: {
      breadcrumb: [{ label: 'Virtual tours' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'virtualTour',
    }
  },

  {
    path: "/add-virtual-tour/",
    name: "Add virtual tour",
    component: () => import('@/pages/virtual-tour/VirtualTourPage.vue'),
    meta: {
      breadcrumb: [{ label: 'Add virtual tour' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'virtualTour',
      hideBreadcrumb: true
    }
  },

  {
    path: "/edit-virtual-tour/:documentId",
    name: "Edit virtual tour",
    component: () => import('@/pages/virtual-tour/VirtualTourPage.vue'),
    meta: {
      breadcrumb: [{ label: 'Edit virtual tour' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'virtualTour',
      hideBreadcrumb: true
    }
  },

  {
    path: "/style-templates/",
    name: "Style galleries",
    component: () => import('@/pages/gis/StyleTemplatesPage.vue'),
    meta: {
      breadcrumb: [{ label: 'Style galleries' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'styleTemplates',
    }
  },

  {
    path: "/style-template/:documentId",
    name: "Style templates",
    component: () => import('@/pages/gis/StyleTemplatePage.vue'),
    meta: {
      breadcrumb: [{ label: 'Style templates' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'styleTemplates',
    }
  },

  {
    path: "/kiosks/",
    name: "KiosksPage",
    component: () => import("@/pages/documents/KiosksPage.vue"),
    meta: {
      breadcrumb: [{label: "Kiosks"}],
      requireLogin: true,
      layout: 'App',
      module: 'kiosk',
      requiredRight: 'view'
    }
  },

  {
    path: "/kiosk/:documentId?",
    name: "Kiosk",
    component: () => import('@/pages/documents/KioskPage.vue'),
    meta: {
      breadcrumb: [{ label: 'Kiosk' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'kiosk',
      hideBreadcrumb: true
    }
  },

  {
    path: "/logs/",
    name: "Logs",
    component: () => import('@/pages/settings/Logs.vue'),
    meta: {
      breadcrumb: [{ label: 'Logs' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view',
      module: 'logs',
      hideBreadcrumb: true
    }
  },

  {
    path: "/finder/",
    name: "FinderPage",
    component: () => import("@/pages/utils/FinderPage.vue"),
    meta: {
      breadcrumb: [{label: "Finder"}],
      requireLogin: true,
      layout: 'App',
      module: 'finder',
      requiredRight: 'view',
      hideBreadcrumb: false
    }
  },

  {
    path: "/mbtiles-management/",
    name: "MbtilesManagementPage",
    component: () => import("@/pages/utils/MbtilesManagementPage.vue"),
    meta: {
      breadcrumb: [{label: "MBTiles Management"}],
      requireLogin: true,
      layout: 'App',
      module: 'MBtilesManagement',
      requiredRight: 'view',
      hideBreadcrumb: false,
      fullWidth: true
    }
  },

  {
    path: "/csc/",
    name: "CscPage",
    component: () => import("@/pages/CscPage.vue"),
    meta: {
      breadcrumb: [{label: "CSC"}],
      requireLogin: false,
      layout: 'Empty'
    }
  },

  {
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: () => import("@/layout/NotFound.vue"),
    meta: {
      requireLogin: false,
      layout: 'NotFound'
    },
  },
]
